import { request } from "../request";

export default {
    getAll: ({}) => request(`profile`, "GET"),
    updateProfile: (params) => request(`profile`, "PUT", params),
    updateProfilePassword: (params) => request(`profile/change_password`, "PUT", params),
};